export const BUNDLE_SKUS = new Set(['glt-bundle-wk']);
